<template>
  <div class="offer col-12 col-md-10">
      <h2 class="offer_title mb-11">{{ $t('Что мы предлагаем') }}</h2>
			<div class="offer_switch-wrap mb-11">
				<button v-metric="'LENDING-SERVICES_CLICK-ON-BUTTON-TO-DESIGNER'" @click="changeList('planner')" class="offer_switch" :class="{'offer_switch--active': offerList === 'planner'}">{{ $t('Проектировщику') }}</button>
				<button v-metric="'LENDING-SERVICES_CLICK-ON-BUTTON-TO-BIM-MANAGER'" @click="changeList('manager')" class="offer_switch" :class="{'offer_switch--active': offerList === 'manager'}">{{ $t('BIM-менеджеру') }}</button>
			</div>
			<transition name="slide-fade">
				<ul v-show="offerList === 'planner'" class="offer-list">
					<li class="offer-list_item">
						<h3 class="offer-list_item-title">
							{{ $t('Запросить обоснование цены на материалы') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Всегда под рукой актуальные и достоверные данные для обоснования цены и конъюнктурного анализа') }}
						</p>
					</li>
					<li class="offer-list_item">
						<h3 class="offer-list_item-title">
							{{ $t('Запросить актуальную стоимость строительства') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Быстрый и точный перерасчёт сметы в реальные деньги на сегодня') }}
						</p>
					</li>
					<li class="offer-list_item">
						<div class="offer-list_item-img-wrap">
							<img class="offer-list_item-img" src="/dist/assets/front_white/img/services/uslugi-2.svg" role="presentation" alt="Получить ТКП">
						</div>
						<h3 class="offer-list_item-title">
							{{ $t('Получить ТКП') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Никаких звонков и общения с продавцами. Защитим от спам-рассылок и звонков, сохранив конфиденциальность данных') }}
						</p>
					</li>
					<li class="offer-list_item">
						<div class="offer-list_item-img-wrap">
							<img class="offer-list_item-img" src="/dist/assets/front_white/img/services/uslugi-3.svg" role="presentation" alt="Запросить прайс-листы">
						</div>
						<h3 class="offer-list_item-title">
							{{ $t('Запросить прайс-листы') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Не тратьте время на поиск, поручите это нам. Больше не придется отвлекаться') }}
						</p>
					</li>
					<li class="offer-list_item">
						<div class="offer-list_item-img-wrap">
							<img class="offer-list_item-img" src="/dist/assets/front_white/img/services/uslugi-4.svg" role="presentation" alt="Рассчитать проект">
						</div>
						<h3 class="offer-list_item-title">
							{{ $t('Рассчитать проект') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Хватит работать с бесконечными таблицами, рассчитывая стоимость каждого пункта вручную. Больше никакой рутинной работы') }}
						</p>
					</li>
					<li class="offer-list_item">
						<div class="offer-list_item-img-wrap">
							<img class="offer-list_item-img" src="/dist/assets/front_white/img/services/uslugi-5.svg" role="presentation" alt="Подобрать аналоги">
						</div>
						<h3 class="offer-list_item-title">
							{{ $t('Подобрать аналоги') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Равные по качеству или даже лучше. Постараемся найти более выгодные решения') }}
						</p>
					</li>
					<li class="offer-list_item">
						<div class="offer-list_item-img-wrap">
							<img class="offer-list_item-img" src="/dist/assets/front_white/img/services/uslugi-6.svg" role="presentation" alt="Убрать дубли в номенклатуре">
						</div>
						<h3 class="offer-list_item-title">
							{{ $t('Убрать дубли в номенклатуре') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Упростим работу с каталогами и сэкономим ваше время') }}
						</p>
					</li>
					<li class="offer-list_item">
						<div class="offer-list_item-img-wrap offer-list_item-img-wrap--last">
							<img class="offer-list_item-img" src="/dist/assets/front_white/img/services/uslugi-7.svg" role="presentation" alt="Другое">
						</div>
						<h3 class="offer-list_item-title">
							{{ $t('Другое') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Вашей задачи нет в списке?') }}
						</p>
						<div class="offer-list_item-button-wrap">
							<button v-metric="'LENDING-SERVICES_CLICK-ON-SEND-REQUEST'" class="offer-list_item-button open-modal" data-modal="sendPhone">{{ $t('Оставьте заявку') }}</button> <span class="offer-list_item-help">{{ $t('— поможем') }}</span>
						</div>
					</li>
				</ul>
			</transition>
			<transition name="slide-fade">
				<ul v-show="offerList === 'manager'" class="offer-list">
					<li class="offer-list_item">
						<h3 class="offer-list_item-title">
							{{ $t('Запросить шаблоны семейств с параметрами ГОСТ и ТУ') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Вам не придется никому звонить. Через нас вы получите качественные данные на всех этапах от проекта, до закупки и эксплуатации') }}
						</p>
					</li>
					<li class="offer-list_item">
						<h3 class="offer-list_item-title">
							{{ $t('Сопоставить номенклатуру и BIM-модели компонентов') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Теперь все данные будут связаны, что позволит создать общую среду') }}
						</p>
					</li>
					<li class="offer-list_item">
						<h3 class="offer-list_item-title offer-list_item-title">
							{{ $t('Сформировать EIR и разработать BEP') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Обеспечим единые требования к результатам моделирования для исполнителей. Вы получите ожидаемый качественный результат') }}
						</p>
					</li>
					<li class="offer-list_item">
						<h3 class="offer-list_item-title">
							{{ $t('Провести аудит или экспертизу BIM-модели') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Равные по качеству или даже лучше. Постараемся найти более выгодные решения') }}
						</p>
					</li>
					<li class="offer-list_item">
						<div class="offer-list_item-img-wrap">
							<img class="offer-list_item-img" src="/dist/assets/front_white/img/services/uslugi-7.svg" role="presentation" alt="Другое">
						</div>
						<h3 class="offer-list_item-title">
							{{ $t('Другое') }}
						</h3>
						<p class="offer-list_item-descr">
							{{ $t('Вашей задачи нет в списке?') }}
						</p>
						<div class="offer-list_item-button-wrap">
							<button v-metric="'LENDING-SERVICES_CLICK-ON-SEND-REQUEST'" class="offer-list_item-button open-modal" data-modal="sendPhone">{{ $t('Оставьте заявку') }}</button> <span class="offer-list_item-help">{{ $t('— поможем') }}</span>
						</div>
					</li>
				</ul>
			</transition>
  </div>
</template>

<script>
export default {
  components: {},
  // components: { modal },
  props: {

  },
  data() {
    return {
			offerList: 'planner'
    };
	},
	methods: {
		changeList(val) {
			this.offerList = '';
			setTimeout(() => this.offerList = val, 220);
		}
	}
};
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/color';
@import './src/front_white/sass/components/settings';

.slide-fade-enter-active {
  transition: all .5s ease .5s;
}
.slide-fade-leave-active {
  // transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.offer {
	color: $darkest-gray;
	height: 100%;
	min-height: 940px;
}

.offer_title {
	text-align: center;
	font-size: 42px;
  font-weight: bold;
}

.offer_switch-wrap {
	display: flex;
	justify-content: center;
}

.offer_switch {
	opacity: 0.75;
	padding: 8px 8px 16px;
	font-size: 24px;
	width: 210px;
	text-align: center;
	border-bottom: solid 2px #eeeeee;

	@media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
			font-size: 14px;
		}
}

.offer_switch--active {
	border-bottom: solid 2px $active;
	opacity: 1;
}

.offer-list {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: 1fr 1fr;
	grid-gap: 14px;

	@media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
			grid-template-columns: 1fr;
			grid-template-rows: auto;
		}
}

.offer-list_item {
	padding: 24px 32px 44px;
	border-radius: 10px;
	box-shadow: 0 40px 40px 0 rgba(0, 0, 0, 0.05);
	background-color: $bg-white;

	@media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
			padding: 14px 16px 22px;
		}

	&:last-child {
		background-color: #f2fbfa;
	}
}

.offer-list_item-img-wrap {
	display: flex;
	align-items: center;
	height: 40px;
	margin-bottom: 14px;

	@media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
			display: none;
		}
}

.offer-list_item-title {
	margin-bottom: 8px;
	font-size: 24px;
	font-weight: bold;

	@media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
			font-size: 18px;
		}
}

.offer-list_item-title--small {
	font-size: 18px;

	@media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
			font-size: 16px;
		}
}

.offer-list_item-descr {
	font-size: 14px;
  font-weight: normal;
}

.offer-list_item-button-wrap {
	margin-top: 4px;
	font-size: 18px;
}

.offer-list_item-button {
	border-bottom: 2px dashed $active;
}

</style>
